import { Component, OnInit, VERSION } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';
import { HttpResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css', '../../shared/styles/common.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoading = false;
  hidePassword = false;
  get_login_json_data: any;

  currentApplicationVersion = environment.appVersion;
  submitted = false;
  password_status = "fa fa-eye-slash";
  hide = true;
  login_details: any;
  version = VERSION.full;
  message: string = '';
  subscription: any;

  constructor(
    private fb: FormBuilder, private authService: AuthService, private data: DataService, private router: Router,
    private snackBar: MatSnackBar,  private toastr: ToastrService,
  ) {
		this.loginForm = this.fb.group({
			email: ['', [Validators.required, Validators.email]],
			password: ['', [Validators.required]],
			rememberMe: [false] 
		});
  }

  ngOnInit(): void {

    // Ensure rememberMe is false initially
    const c = this.loginForm.value;
    c.rememberMe = false;
    this.loginForm.patchValue(c);

    const rememberedEmail = localStorage.getItem('remembered_email');
		const rememberedPassword = localStorage.getItem('remembered_password');
		const rememberedChecked = localStorage.getItem('remembered_checked');
	
		if (rememberedChecked && rememberedEmail && rememberedPassword) {
			this.loginForm.patchValue({
				email: rememberedEmail,
				password: rememberedPassword,
				rememberMe: true
			});
		}

    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/dashboard']);
    }
  }
  get f() { return this.loginForm.controls; }

  // onSubmit(): void {
  //   if (this.loginForm.valid) {
  //     this.isLoading = true;
  //     const credentials = {
  //       email: this.loginForm.get('email')?.value,
  //       password: this.loginForm.get('password')?.value,
  //       rememberMe: this.loginForm.get('rememberMe')?.value
  //     };

  //     this.authService.login(credentials).subscribe({
  //       next: () => {
  //         this.snackBar.open('Login successful!', 'Close', { duration: 3000 });
  //         this.router.navigate(['/dashboard']);
  //       },
  //       error: (error) => {
  //         this.isLoading = false;
  //         const errorMessage = error.error?.message || 'Login failed. Please try again.';
  //         this.snackBar.open(errorMessage, 'Close', { duration: 3000 });
  //       },
  //       complete: () => {
  //         this.isLoading = false;
  //       }
  //     });
  //   } else {
  //     this.markFormGroupTouched(this.loginForm);
  //   }
  // }

  onLoginButtonClicked(email: string, password: string) {
    //debugger
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    const rememberMe = this.loginForm.value['rememberMe'];
    this.authService.login(email, password, 'email', 'login').subscribe((res: HttpResponse<any>) => {
      //console.log('--res',res)
      this.get_login_json_data = res.body;
      

      // If password mode is reset //
      if (res.body?.data?.password_mode === 'reset') {
        this.router.navigate(['/reset-password'], {
          queryParams: { token: password, email: email }
        });
        return;
      }
      // If password mode is reset //

      if (!res.body.error && res.body.data.email_verified) {
        // this.show_spinner()

        this.authService.create_user_vitacape_consumer(this.get_login_json_data.data.pk + "@digicoffer.com", this.get_login_json_data.token.slice(0, 20), this.get_login_json_data.data.first_name, this.get_login_json_data.data.pk).subscribe(resp => {
          this.router.navigate(['/dashboard']);
        })
        // this.router.navigate(['/dashboard']);

        // Store credentials if 'Remember Me' is checked
        if (rememberMe) {
          localStorage.setItem('remembered_email', email);
          localStorage.setItem('remembered_password', password);
          localStorage.setItem('remembered_checked', 'true');
        } else {
          localStorage.removeItem('remembered_email');
          localStorage.removeItem('remembered_password');
          localStorage.removeItem('remembered_checked');
        }

      
      }
      else if (!res.body.error && !res.body.data.email_verified) {
        this.data.changeMessage(email);
        this.authService.resend_token(this.message).subscribe((respons: any) => {
          console.log(respons);
        })
        this.router.navigate(['/mail-verification']);
        // //console.log("here is the mail from login - ", this.message);
      }
      else {
        if (res.body.msg.email) {
          this.toastr.error(res.body.msg.email, 'Error!');
        } else {
          this.toastr.error(res.body.msg, 'Error!');
        }
      }
    })
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }
  restricttextSpace(event: any) {
		let inputValue: string = event.target.value;
		inputValue = inputValue.replace(/^\s+/, '');
		inputValue = inputValue.replace(/\s{2,}/g, ' ');
		event.target.value = inputValue;
		return;
	}
}

